module.exports = __webpack_public_path__ + "static/0058-ad44827fb9ff0a38ac58cff20aaac3a3.png";